import { FleekError } from './FleekError';

type DnsConfigAlreadyExistsErrorOptions = {
  name: string;
};

export class DnsConfigAlreadyExistsError extends FleekError<DnsConfigAlreadyExistsErrorOptions> {
  public name = 'DnsConfigAlreadyExistsError';

  toString = () => `DNS config already exists for "${this.data.name}".`;
}
